import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Inputcount from './Inputcount';

class Sri extends Component {
  render(){
    return(
        <div>
          <form className="sri-div">
            <div className="flex-divs-style-inner" style={{border: 0}}><h1>Sri</h1></div>
            <Inputcount title="1" main="sri" group="1"/>
            <Inputcount title="2" main="sri" group="2"/>
            <Inputcount title="3" main="sri" group="3"/>
            <Inputcount title="4" main="sri" group="4"/>
            <Inputcount title="5" main="sri" group="5"/>
            <Inputcount title="6" main="sri" group="6"/>
            <Inputcount title="7" main="sri" group="7"/>
            <Inputcount title="8" main="sri" group="8"/>
            <Inputcount title="9" main="sri" group="9"/>
            <Inputcount title="10" main="sri" group="10"/>
            <Inputcount title="11" main="sri" group="11"/>
            <Inputcount title="12" main="sri" group="12"/>
          </form>
        </div>
    );
  }
}

export default withRouter(Sri);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Sri.js